export default __webpack_public_path__ + "static/media/BLR27.4a4cbb3b.jpg";